import { ReactNode } from "react";
import { ClearIndicatorProps } from "react-select";

import { RemoveFilteringIcon } from "./remove-filtering-icon";

export const ClearIndicator = (
  props: ClearIndicatorProps<unknown, true>,
): ReactNode => {
  const {
    children,
    innerProps: { ref, ...restInnerProps },
  } = props;

  return (
    <div {...restInnerProps} ref={ref}>
      <div style={{ marginInlineEnd: "5px" }}>
        <RemoveFilteringIcon />
      </div>
      {children}
    </div>
  );
};
